import css from './style.module.scss';

export const PulseLoaderContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className={css.container}>{children}</div>;
};
